<template>
  <!-- red dogadjaja u blokovima (Top dogadjaji i kategorije na pocetnoj); izgled isti kao red oglasa (AdRow, assets/scss/adRow.scss) -->
  <article class="adr adr-solo noselect" :class="{ 'adr-noimg': !showImage }">
    <NuxtImg
      v-if="showImage"
      :src="$getImageSrc(event.img_cover)"
      :alt="event.title"
      fit="cover"
      width="60"
      height="60"
      loading="lazy"
      decoding="async"
      class="adr-img"
    />

    <!-- jedini link u redu (razvucen preko celog reda, vidi AdRow) -->
    <div class="adr-title">
      <NuxtLink :to="link" class="adr-link">{{ event.title }}</NuxtLink>
    </div>

    <span v-if="showPlace && event.place_name" class="adr-meta">{{ event.place_name }}</span>

    <!-- datum: svetloplava pilula sa plavim tekstom, broj veci od meseca -->
    <span class="adr-pill adr-pill-date">
      <template v-if="date.text">{{ date.text }}</template>
      <template v-else>
        <template v-for="(p, i) in date.parts" :key="i">
          <template v-if="i"> - </template>
          <span class="adr-dd">{{ p.day }}</span> <span class="adr-dm">{{ p.month }}</span>
        </template>
      </template>
    </span>
  </article>
</template>

<script setup>
const props = defineProps({
  event: { type: Object, required: true },
  // false: red bez slike
  showImage: { type: Boolean, default: true },
  // false: bez mesta (npr. stocne pijace, gde je mesto vec u naslovu)
  showPlace: { type: Boolean, default: true },
})

const { $srbTolat } = useNuxtApp()
const { eventDateParts } = useEventDates()
const date = computed(() => eventDateParts(props.event))

const link = computed(() => ({
  name: 'kalendar-dogadjaja-event-title',
  params: {
    event: $srbTolat.srbTolat(props.event.category_name),
    title: $srbTolat.srbTolat(props.event.title),
  },
}))
</script>
